










































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

import {
  NetworkErrorEmptyState,
  SwitchListItem,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  AsyncState,
  DropDownButton,
  ModalState,
  PaymentMethod,
  PaymentMethodPayload
} from '@/models'

@Component({
  components: {
    MobileLayout,
    NetworkErrorEmptyState,
    SwitchListItem,
    VsLoading
  }
})
export default class PaymentMethodDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly paymentMethodId!: number

  loadState = new AsyncState()
  changeIsPublicState = new AsyncState()

  removeState = new ModalState()

  isPublic = false
  skipOnIsPublicChange = false

  showCanNotRemoveDialog = false

  get buttons (): DropDownButton[] {
    if (this.paymentMethod === null) {
      return []
    }

    return [
      {
        icon: 'more_vert',
        color: 'dark',
        items: [
          {
            text: 'Remover',
            handler: () => {
              this.removeState.isActive = true
            }
          }
        ]
      }
    ]
  }

  get isWaiting () {
    return this.changeIsPublicState.isPending || this.removeState.isPending
  }

  get paymentMethod (): PaymentMethod | null {
    return this.paymentMethodById(this.paymentMethodId)
  }

  get title () {
    if (this.paymentMethod !== null) {
      return this.paymentMethod.name
    }

    return this.loadState.isPending
      ? null
      : 'Meio de Pagamento'
  }

  @Getter('paymentMethods/allowedPaymentMethodById')
  readonly paymentMethodById!: (id: number) => PaymentMethod | null

  @Action('paymentMethods/fetchAllowedPaymentMethod')
  loadPaymentMethod!: (id: number) => Promise<void>

  @Action('paymentMethods/updateAllowedPaymentMethod')
  updateAllowedPaymentMethod!: (payload: PaymentMethodPayload) => Promise<void>

  @Action('paymentMethods/unbindPaymentMethod')
  unbindPaymentMethod!: (id: number) => Promise<void>

  @Watch('isPublic')
  async onIsPublicChange (val: boolean, old: boolean) {
    if (this.paymentMethod === null) {
      return
    }

    if (this.skipOnIsPublicChange) {
      this.skipOnIsPublicChange = false
      return
    }

    try {
      await this.changeIsPublicState.handle(
        this.handleUpdate({
          id: this.paymentMethod.id,
          public: val
        })
      )
    } catch (e) {
      this.skipOnIsPublicChange = true
      this.isPublic = old

      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async created () {
    if (this.paymentMethod === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.paymentMethod && this.isPublic !== this.paymentMethod.public) {
      this.skipOnIsPublicChange = true
      this.isPublic = this.paymentMethod.public
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadPaymentMethod(this.paymentMethodId)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleUnbind () {
    try {
      await this.removeState.handle(
        this.unbindPaymentMethod(this.paymentMethodId)
      )

      this.$router.back()
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível remover.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleUpdate (payload: PaymentMethodPayload) {
    return this.updateAllowedPaymentMethod(payload)
  }
}
